const CLAVE = "cantapp-theme";

export const getTema = () => {
  try {
    return localStorage.getItem(CLAVE) || "light";
  } catch {
    return "light";
  }
};

export const aplicarTema = (tema) => {
  document.documentElement.setAttribute("data-theme", tema);
};

export const setTema = (tema) => {
  try {
    localStorage.setItem(CLAVE, tema);
  } catch {
    // localStorage puede no estar disponible (modo privado, etc.) --
    // el tema simplemente no persiste entre sesiones en ese caso.
  }
  aplicarTema(tema);
};

// se llama una vez al arrancar la app, antes del primer render, para
// no mostrar el tema claro un instante y después saltar a oscuro.
export const inicializarTema = () => {
  aplicarTema(getTema());
};
